(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-full-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cfw-navigation')){
  customElements.define('cfw-navigation',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      const fit=()=>{this.querySelectorAll('.cfw-nav-details[open] .cfw-nav-panel').forEach(panel=>panel.style.setProperty('--cfw-panel-height',Math.max(120,window.innerHeight-panel.getBoundingClientRect().top-16)+'px'))};
      window.addEventListener('resize',fit,options);window.addEventListener('scroll',fit,{...options,passive:true});
      const close=(detail,restore=false)=>{detail.open=false;if(restore)detail.querySelector('summary').focus()};
      this.querySelectorAll('.cfw-nav-details').forEach(detail=>{
        detail.addEventListener('toggle',()=>{if(detail.open)this.querySelectorAll('.cfw-nav-details[open]').forEach(other=>{if(other!==detail)close(other)});fit()},options);
        detail.querySelector('.cfw-nav-close').addEventListener('click',()=>close(detail,true),options);
      });
      document.addEventListener('click',event=>{if(!this.contains(event.target))this.querySelectorAll('details[open]').forEach(d=>close(d))},options);
      this.addEventListener('keydown',event=>{if(event.key==='Escape'){const d=this.querySelector('details[open]');if(d){event.preventDefault();close(d,true)}}},options);
      this.addEventListener('focusout',event=>{if(event.relatedTarget&&this.contains(event.relatedTarget))return;setTimeout(()=>{if(!this.contains(document.activeElement))this.querySelectorAll('details[open]').forEach(d=>close(d))},0)},options);
    }
    disconnectedCallback(){this.abort?.abort()}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mobile-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cfw-mobile-navigation')){
 customElements.define('cfw-mobile-navigation',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const options={signal:this.abort.signal};
   const wrapper=this.closest('.mobile-toggle-wrapper');const trigger=wrapper.querySelector('.mobile-toggle');
   const close=()=>{wrapper.open=false;wrapper.classList.remove('active');document.body.classList.remove('overflow-hidden');this.querySelectorAll('details[open]').forEach(d=>d.open=false);trigger.focus()};
   this.querySelector('[data-cfw-close]').addEventListener('click',close,options);
   this.querySelectorAll('.cfw-mobile-back').forEach(button=>button.addEventListener('click',()=>{const detail=button.closest('details');detail.open=false;detail.classList.remove('menu-opening','submenu-open');detail.querySelector('summary').focus()},options));
   this.querySelectorAll('.cfw-mobile-level').forEach(detail=>detail.addEventListener('toggle',()=>{if(detail.open)detail.querySelector('.cfw-mobile-back').focus()},options));
   wrapper.addEventListener('toggle',()=>{if(wrapper.open){this.querySelector('[data-cfw-close]').focus()}else{document.body.classList.remove('overflow-hidden');this.querySelectorAll('details[open]').forEach(d=>d.open=false)}},options);
   wrapper.addEventListener('keydown',event=>{
    if(event.key==='Escape'){event.preventDefault();event.stopPropagation();const open=[...this.querySelectorAll('details[open]')];if(open.length){const detail=open.at(-1);detail.open=false;detail.querySelector('summary').focus()}else close()}
    if(event.key==='Tab'&&wrapper.open){const opened=[...this.querySelectorAll('details[open]')].at(-1);const scope=opened?opened.querySelector('.cfw-mobile-panel'):this;const focusables=[...scope.querySelectorAll('a[href],button,summary')].filter(el=>el.getClientRects().length);const first=focusables[0],last=focusables.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}}
   },options);
  }
  disconnectedCallback(){this.abort?.abort()}
 });
}
  } catch(e) { console.error(e); }
})();

})();
